import * as React from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { normalizeString } from "../utils/normalizeString";
import "./InfoDrawer.scss";
import { Link } from "@mui/material";

export default function InfoDrawer({ data, member, heading }) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  return (
    <div>
      <p onClick={toggleDrawer("right", true)}>{heading}</p>
      {/* <SwipeableDrawer
        anchor={"right"}
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
        hideBackdrop={true}
      >
        {data.map((item) => {
          return (
            <Accordion expandIcon={<ExpandMoreIcon />}>
              <AccordionSummary>
                <h1 className="infodrawer-accordion-summary"> {item.name}</h1>
              </AccordionSummary>
              <AccordionDetails>
                {Object.keys(item).map((w) => {
                  return (
                    <span className="infodrawer-accordion-details">
                      <p className="header">{normalizeString(w)}</p>
                      <p className="info">{item[w]}</p>
                    </span>
                  );
                })}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </SwipeableDrawer> */}
    </div>
  );
}
